import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from '../features/auth/contexts/AuthContext';
import { LanguageProvider } from '../shared/contexts/LanguageContext';
import { DoctorInfoProvider } from '../features/registration/contexts/DoctorInfoContext';
import { ErrorProvider } from '../shared/contexts/ErrorContext';
import ErrorNotification from '../shared/components/notification/ErrorNotification';
import UpdateGate from '../shared/components/UpdateGate';
import AppRouter from './router/AppRouter';
import { DesignProvider, isV2Enabled, useDesign } from '../v2/design/DesignContext';
import DesignSwitchConfirm from '../v2/design/DesignSwitchConfirm';

// The classic error toast belongs to the classic design; the new design shows errors inline and in its own toasts.
const ClassicErrorNotification = () => {
  const { isV2 } = useDesign();
  return isV2 ? null : <ErrorNotification />;
};

const App = () => {
  return (
    <DesignProvider>
      <LanguageProvider>
        <UpdateGate />
        {/* Only a v2-enabled build can switch design (REACT_APP_ENABLE_V2=true). */}
        {isV2Enabled() && <DesignSwitchConfirm />}
        <ErrorProvider>
          <AuthProvider>
            <DoctorInfoProvider>
              <Router>
                <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
                  <ClassicErrorNotification />
                  <AppRouter />
                </div>
              </Router>
            </DoctorInfoProvider>
          </AuthProvider>
        </ErrorProvider>
      </LanguageProvider>
    </DesignProvider>
  );
}

export default App;
